// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Common = require("../utils/Common.res.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.res.js");
var MM_wrk_client = require("./MM_wrk_client.res.js");
var MM_wrk_editor = require("./MM_wrk_editor.res.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");

var procName = "MM_wrk_LoadCtx";

function reqToStr(req) {
  return "LoadMmContext";
}

function respToStr(resp) {
  if (resp.TAG === "MmContextLoadProgress") {
    return "MmContextLoadProgress(pct=" + String(resp.pct) + ")";
  } else {
    return "MmContextLoaded";
  }
}

function beginLoadingMmContext(scopes, descrRegexToDisc, labelRegexToDisc, descrRegexToDepr, labelRegexToDepr, onProgress, onDone) {
  MM_wrk_client.beginWorkerInteraction(procName, {
        TAG: "LoadMmContext",
        scopes: scopes,
        descrRegexToDisc: descrRegexToDisc,
        labelRegexToDisc: labelRegexToDisc,
        descrRegexToDepr: descrRegexToDepr,
        labelRegexToDepr: labelRegexToDepr
      }, (function (resp, param, endWorkerInteraction) {
          if (resp.TAG === "MmContextLoadProgress") {
            return onProgress(resp.pct);
          }
          endWorkerInteraction();
          onDone(resp.ctx);
        }), undefined, undefined, undefined);
}

function strToRegexOpt(str) {
  var str$1 = str.trim();
  if (str$1.length === 0) {
    return ;
  }
  var msg = Common.strToRegex(str$1);
  if (msg.TAG === "Ok") {
    return Caml_option.some(msg._0);
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "Could not parse a regex: " + msg._0
        },
        Error: new Error()
      };
}

function processOnWorkerSide(req, sendToClient) {
  var labelRegexToDepr = req.labelRegexToDepr;
  var descrRegexToDepr = req.descrRegexToDepr;
  var labelRegexToDisc = req.labelRegexToDisc;
  var descrRegexToDisc = req.descrRegexToDisc;
  var scopes = req.scopes;
  var totalNumOfAssertions = Core__Array.reduce(scopes, 0, (function (a, e) {
          return a + e.expectedNumOfAssertions | 0;
        }));
  var weights = scopes.map(function (s) {
        return s.expectedNumOfAssertions / totalNumOfAssertions;
      });
  try {
    var ctx = MM_context.createContext(undefined, undefined);
    for(var i = 0 ,i_finish = scopes.length; i < i_finish; ++i){
      var scope = scopes[i];
      var basePct = Core__Array.reduceWithIndex(weights, 0, (function(i){
          return function (a, w, idx) {
            if (idx < i) {
              return a + w;
            } else {
              return a;
            }
          }
          }(i)));
      var weight = weights[i];
      MM_context.loadContext(scopes[i].ast, Caml_option.some(ctx), scope.stopBefore, scope.stopAfter, undefined, scope.expectedNumOfAssertions, strToRegexOpt(descrRegexToDisc), strToRegexOpt(labelRegexToDisc), strToRegexOpt(descrRegexToDepr), strToRegexOpt(labelRegexToDepr), (function(basePct,weight){
          return function (pct) {
            sendToClient({
                  TAG: "MmContextLoadProgress",
                  pct: basePct + pct * weight
                });
          }
          }(basePct,weight)), undefined);
      if (scope.resetNestingLevel) {
        while(MM_context.getNestingLevel(ctx) !== 0) {
          MM_context.closeChildContext(ctx);
        };
      }
      
    }
    sendToClient({
          TAG: "MmContextLoadProgress",
          pct: 1
        });
    return sendToClient({
                TAG: "MmContextLoaded",
                ctx: {
                  TAG: "Ok",
                  _0: ctx
                }
              });
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === Common.MmException) {
      return sendToClient({
                  TAG: "MmContextLoaded",
                  ctx: {
                    TAG: "Error",
                    _0: exn._1.msg
                  }
                });
    }
    if (exn.RE_EXN_ID === Js_exn.$$Error) {
      return sendToClient({
                  TAG: "MmContextLoaded",
                  ctx: {
                    TAG: "Error",
                    _0: Belt_Option.getWithDefault(exn._1.message, "Internal error.")
                  }
                });
    }
    throw exn;
  }
}

function getAllLabelsAfterReading(src) {
  var match = MM_wrk_editor.readInstrFromStr(src.readInstr);
  switch (match) {
    case "ReadAll" :
        return [
                undefined,
                undefined,
                src.allLabels
              ];
    case "StopBefore" :
        var idx = src.allLabels.findIndex(function (label) {
              return label === src.label;
            });
        if (idx !== -1) {
          return [
                  src.label,
                  undefined,
                  src.allLabels.slice(0, idx)
                ];
        } else {
          return [
                  undefined,
                  undefined,
                  src.allLabels
                ];
        }
    case "StopAfter" :
        var idx$1 = src.allLabels.findIndex(function (label) {
              return label === src.label;
            });
        if (idx$1 !== -1) {
          return [
                  undefined,
                  src.label,
                  src.allLabels.slice(0, idx$1 + 1 | 0)
                ];
        } else {
          return [
                  undefined,
                  undefined,
                  src.allLabels
                ];
        }
    
  }
}

function createMmScopesForFrame(srcs, label) {
  var res = [];
  Core__Array.reduce(srcs, false, (function (found, src) {
          if (found) {
            return found;
          } else {
            var match = getAllLabelsAfterReading(src);
            var allLabels = match[2];
            var match$1 = allLabels.includes(label) ? [
                label,
                undefined,
                allLabels.indexOf(label),
                false
              ] : [
                match[0],
                match[1],
                allLabels.length,
                true
              ];
            var expectedNumOfAssertions = match$1[2];
            var ast = src.ast;
            var ast$1;
            if (ast !== undefined) {
              ast$1 = ast;
            } else {
              throw {
                    RE_EXN_ID: Common.MmException,
                    _1: {
                      msg: "Cannot create MM context for a frame without ast."
                    },
                    Error: new Error()
                  };
            }
            var mmScope_stopBefore = match$1[0];
            var mmScope_stopAfter = match$1[1];
            var mmScope_resetNestingLevel = match$1[3];
            var mmScope = {
              ast: ast$1,
              expectedNumOfAssertions: expectedNumOfAssertions,
              stopBefore: mmScope_stopBefore,
              stopAfter: mmScope_stopAfter,
              resetNestingLevel: mmScope_resetNestingLevel
            };
            res.push(mmScope);
            return allLabels.length !== expectedNumOfAssertions;
          }
        }));
  return res;
}

exports.procName = procName;
exports.beginLoadingMmContext = beginLoadingMmContext;
exports.processOnWorkerSide = processOnWorkerSide;
exports.reqToStr = reqToStr;
exports.respToStr = respToStr;
exports.createMmScopesForFrame = createMmScopesForFrame;
/* Common Not a pure module */
